import { Spinner, Text } from "@chakra-ui/react";

import { useDappSDKProvider } from "dapp-sdk-v2";

const NodeOperatorCount = () => {
  const { nodeOperatorsCount } = useDappSDKProvider();

  return (
    <>
      {nodeOperatorsCount.isLoading ? (
        <Spinner size="xs" pb="2px" />
      ) : (
        <Text fontSize={{ base: "12px", xl: "14px" }} fontWeight="600">
          {nodeOperatorsCount.data.total || "-"}
        </Text>
      )}
    </>
  );
};

export default NodeOperatorCount;
